import React, { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const FacetPlanContext = createContext(undefined);

const FacetPlanProvider = ({ children }) => {
  const [context, setContext] = useState({});

  const dispatch = async () => {
    // Grab data with dispatch and set the context with setContext
    setContext({ facetPlan: {} });
  };

  useEffect(() => {
    dispatch();
  }, []);

  return (
    <FacetPlanContext.Provider value={{ ...context, dispatch }}>
      {children}
    </FacetPlanContext.Provider>
  );
};

FacetPlanProvider.propTypes = {
  children: PropTypes.object.isRequired,
};

export function useFacetPlanContext() {
  const context = React.useContext(FacetPlanContext);

  if (context === undefined) {
    throw new Error('useFacetPlanContext must be used within a FacetPlanProvider');
  }

  return context;
}

export default FacetPlanProvider;
